var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _polygon4, _polygon5, _polygon6, _path6, _path7, _polygon7, _path8, _path9, _polygon8, _path0, _polygon9, _rect, _polygon0, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFnma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    viewBox: "0 0 220.89 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0066a4;}.cls-2{fill:#085fa0;}.cls-3{fill:url(#Sfumatura_senza_nome_4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    x1: 198.72,
    y1: 350.51,
    x2: 200.56,
    y2: 350.51,
    gradientTransform: "translate(3702.25 6485.77) rotate(-180) scale(18.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aecc53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#aecc53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9ec550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4aa044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#15883c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#01803a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01803a"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.3 36.5 46.3 42.87 47.69 42.87 47.69 40.31 50.7 40.31 50.7 39.04 47.69 39.04 47.69 37.77 51.1 37.77 51.1 36.5 46.3 36.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.08 36.5 57.08 40.42 54.1 36.5 52.8 36.5 52.8 42.87 54.19 42.87 54.19 38.82 57.28 42.87 58.47 42.87 58.47 36.5 57.08 36.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.18 36.49 63.64 40.41 62.1 36.49 60.17 36.49 60.17 42.87 61.56 42.87 61.56 38.63 63.34 42.87 63.93 42.87 65.72 38.63 65.72 42.87 67.11 42.87 67.11 36.49 65.18 36.49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.24,39.7v-.02c0-1.69,1.24-3.19,3.09-3.19,1.04,0,1.69,.3,2.3,.82l-.45,.53c-.48-.41-1-.7-1.88-.7-1.37,0-2.34,1.15-2.34,2.53v.02c0,1.47,.94,2.57,2.44,2.57,.71,0,1.36-.27,1.78-.62v-1.53h-1.88v-.62h2.55v2.46c-.57,.51-1.44,.94-2.48,.94-1.94,0-3.14-1.41-3.14-3.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.15,39.75c.92,0,1.59-.48,1.59-1.27v-.02c0-.76-.58-1.22-1.58-1.22h-1.9v2.51h1.89Zm-2.59-3.15h2.65c.76,0,1.37,.23,1.75,.62,.3,.3,.47,.73,.47,1.22v.02c0,1.02-.7,1.62-1.67,1.8l1.9,2.52h-.86l-1.79-2.4h-1.76v2.4h-.7v-6.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.24,39.7v-.02c0-1.4-1.02-2.55-2.43-2.55s-2.41,1.13-2.41,2.53v.02c0,1.4,1.02,2.55,2.43,2.55s2.42-1.13,2.42-2.53m-5.57,0v-.02c0-1.7,1.28-3.19,3.16-3.19s3.14,1.47,3.14,3.17v.02c0,1.7-1.28,3.19-3.16,3.19s-3.14-1.47-3.14-3.17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.32,40.14v-3.59h.7v3.54c0,1.33,.7,2.08,1.89,2.08s1.86-.69,1.86-2.04v-3.59h.7v3.54c0,1.8-1.03,2.73-2.57,2.73s-2.57-.93-2.57-2.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.38,39.96c1.02,0,1.69-.54,1.69-1.36v-.02c0-.88-.66-1.34-1.66-1.34h-1.56v2.72h1.52Zm-2.22-3.36h2.31c1.39,0,2.31,.74,2.31,1.96v.02c0,1.33-1.11,2.02-2.43,2.02h-1.5v2.18h-.7v-6.17Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.3 17.34 56.03 17.34 56.03 19.9 49.11 19.9 49.11 22.62 55.21 22.62 55.21 25.17 49.11 25.17 49.11 30.11 46.3 30.11 46.3 17.34"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.27 17.34 60.86 17.34 66.84 25.21 66.84 17.34 69.62 17.34 69.62 30.11 67.23 30.11 61.04 22 61.04 30.11 58.27 30.11 58.27 17.34"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.68 17.34 75.71 17.34 79.07 22.74 82.42 17.34 85.45 17.34 85.45 30.11 82.66 30.11 82.66 21.78 79.07 27.23 78.99 27.23 75.44 21.83 75.44 30.11 72.68 30.11 72.68 17.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.52,17.25h1.35l5.82,12.86h-1.55l-1.5-3.38h-6.95l-1.51,3.38h-1.48l5.82-12.86Zm3.56,8.17l-2.9-6.49-2.92,6.49h5.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.55,24.77v-7.42h1.44v7.33c0,2.75,1.48,4.31,3.9,4.31s3.85-1.42,3.85-4.21v-7.42h1.44v7.31c0,3.72-2.13,5.66-5.33,5.66s-5.31-1.93-5.31-5.54"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.97 18.68 115.68 18.68 115.68 17.34 125.72 17.34 125.72 18.68 121.43 18.68 121.43 30.11 119.97 30.11 119.97 18.68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.98,23.77v-.04c0-3.52,2.65-6.6,6.53-6.6s6.49,3.05,6.49,6.57v.04c0,3.52-2.64,6.6-6.53,6.6s-6.49-3.05-6.49-6.57m11.53,0v-.04c0-2.9-2.12-5.27-5.03-5.27s-5,2.33-5,5.23v.04c0,2.9,2.12,5.27,5.03,5.27s5-2.34,5-5.24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.12,28.25l.89-1.06c1.33,1.2,2.61,1.81,4.38,1.81s2.85-.91,2.85-2.17v-.04c0-1.19-.64-1.86-3.32-2.43-2.94-.64-4.29-1.59-4.29-3.68v-.04c0-2.01,1.77-3.48,4.19-3.48,1.86,0,3.19,.53,4.49,1.57l-.84,1.11c-1.19-.96-2.37-1.38-3.69-1.38-1.66,0-2.72,.91-2.72,2.06v.04c0,1.2,.66,1.88,3.47,2.48,2.85,.62,4.16,1.66,4.16,3.61v.04c0,2.19-1.83,3.61-4.36,3.61-2.02,0-3.68-.68-5.22-2.04"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "154.64 17.34 163.87 17.34 163.87 18.66 156.08 18.66 156.08 23.02 163.05 23.02 163.05 24.33 156.08 24.33 156.08 28.8 163.96 28.8 163.96 30.11 154.64 30.11 154.64 17.34"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.86,17.34h5.49c1.57,0,2.83,.47,3.63,1.28,.62,.62,.99,1.51,.99,2.52v.04c0,2.11-1.46,3.36-3.47,3.72l3.92,5.22h-1.77l-3.7-4.96h-3.65v4.96h-1.44v-12.77Zm5.36,6.51c1.92,0,3.28-.99,3.28-2.63v-.03c0-1.57-1.2-2.52-3.26-2.52h-3.94v5.18h3.92Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.59 17.34 180.2 17.34 184.74 28.34 189.3 17.34 190.85 17.34 185.36 30.2 184.08 30.2 178.59 17.34"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 193.5,
    y: 17.35,
    width: 1.44,
    height: 12.77
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "198.1 29.15 206.36 18.64 198.37 18.64 198.37 17.35 208.33 17.35 208.33 18.31 200.05 28.82 208.33 28.82 208.33 30.12 198.1 30.12 198.1 29.15"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.45,
    y: 17.35,
    width: 1.44,
    height: 12.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.26 27.97 12.46 27.97 8.21 32.22 37.99 32.22 42.26 27.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.46,
    y: 17.35,
    width: 25.53,
    height: 8.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.47,
    y: 34.38,
    width: 25.52,
    height: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnma);
export default __webpack_public_path__ + "static/media/FNMA.ac1996b75b254473974d9816c6faa72a.svg";
export { ForwardRef as ReactComponent };